
export class AlertType {
    AlertTypeID: number;
    DeliveryMechEmail: boolean;
    EmailTemplateID: number | null;
    DeliveryMechSMS: boolean;
    SMSTemplateID: number | null;
    Name: string;
    Description: string;
    EventTopic: string;
}

export class AlertEnrollmentScope {
    AlertEnrollmentScopeID: number | null;
    AlertEnrollmentID: number | null;
    EntityTypeID: string;
    EntityID: number | null;
    IncludeChildren: boolean | null;
    EntityName: string;
}

export class EnrollAlertInq {
    EntityID: number | null;
    EntityTypeID: string;
    EventTopic: string;
    AlertTypeID: number | null;
    SystemID: string;
    EnrolledOnly: boolean | null;
}

export class EnrollAlert {
    AlertEnrollmentID: number | null;
    UserID: number | null;
    AlertTypeID: number | null;
    DeliverEmail: boolean | null;
    Email: string;
    EmailVerified: boolean | null;
    DeliverSMS: boolean | null;
    SMSPhone: string;
    SMSCountryCode: string;
    SMSPhoneVerified: boolean | null;
    DigestPeriodMinutes: number | null;

    constructor(AlertEnrollmentID = null,
        UserID = null,
        AlertTypeID = null,
        DeliverEmail = null,
        Email = null,
        EmailVerified = null,
        DeliverSMS = null,
        SMSPhone = null,
        SMSCountryCode = null,
        SMSPhoneVerified = null,
        DigestPeriodMinutes = null) {

        this.AlertEnrollmentID = null;
        this.UserID = null;
        this.AlertTypeID = null;
        this.DeliverEmail = null;
        this.Email = null;
        this.EmailVerified = null;
        this.DeliverSMS = null;
        this.SMSPhone = null;
        this.SMSCountryCode = null;
        this.SMSPhoneVerified = null;
        this.DigestPeriodMinutes = null;
    }
}

export class EnrolledAlert extends EnrollAlert {
    UsingDefaultEmail: boolean;
    UsingDefaultSMSPhone: boolean;
}

export class ContactVerification {
    Email: string;
    SMSPhone: string;
    Code: string;
}


export class AuthUser {
    AuthenUId: number | null;
    FirstName: string;
    LastName: string;
    ContactEmail: string;
    ContactEmailVerified: boolean | null;
    AlertDefaultSMSPhone: string;
    AlertDefaultSMSPhoneVerified: boolean | null;
    AlertDefaultSMSCountryCode: string;
}

export class AlertsList {
    SMSCountryCode: string;
    UsingDefaultSMSPhone: boolean | null;
    SMSPhone: string;
    DeliverSMS: boolean | null;
    EmailVerified: boolean | null;
    UsingDefaultEmail: boolean | null;
    Email: string;
    DeliverEmail: boolean | null;
    AlertEnrollmentID: number | null;
    EventTopic: string;
    Description: string;
    Name: string;
    SMSTemplateID: number | null;
    DeliveryMechSMS: boolean;
    EmailTemplateID: number | null;
    DeliveryMechEmail: boolean | null;
    AlertTypeID: number;
    SMSPhoneVerified: boolean | null;
    DigestPeriodMinutes: number | null;
}


export class AlertScopesList {
    SalesEntityID: number;
    Name: string;
    ChildCount: number;
    AlertEnrollmentScopeID: number | null;
    EntityTypeID: string;
    EntityID: number | null;
    IncludeChildren: boolean | null;
}


export class UserAlertSearch {
    EntityID: number | null;
    EntityTypeID: string;
    ShowNew: boolean | null;
    ShowViewed: boolean | null;
    FromDTM: Date | string | null;
    ToDTM: Date | string | null;
    AlertTypeIDList: string;
    StartPage: number | null;
    MaxRows: number | null;
    SortCol: string;
    SortDir: string;
    VisibleAfterDTM: Date | string | null;
}

export class UserAlertUpdate {
    UserAlertID: number;
    ViewedDTM: Date | string | null;
    EmailSentDTM: Date | string | null;
    SMSSentDTM: Date | string | null;
}


export class UserAlert {
    UserAlertID: number | null;
    UserID: number;
    AlertTypeID: number;
    CreatedDTM: Date | string | null;
    ViewedDTM: Date | string | null;
    Subject: string;
    Description: string;
    Content: string;
    EntityTypeID: string;
    EntityID: number | null;
    EmailSendAfterDTM: Date | string | null;
    EmailSentDTM: Date | string | null;
    SMSSendAfterDTM: Date | string | null;
    SMSSentDTM: Date | string | null;
    AlertEnrollmentID: number | null;
}

export class UserAlertList extends UserAlert {
    AlertTypeName: string;
}

export class UserAlertResponse {
    TotalRows: number;
    ual: UserAlertList[];
}

export class AlertEnrollmentContact {
    AlertEnrollmentContactID: number | null;
    AlertContactID: number | null;
    AlertEnrollmentID: number | null;
    Name: string;
    ContactEmail: string;
    ContactEmailVerified: boolean;
    DeliverEmail: boolean | null;
    AlertDefaultSMSCountryCode: string;
    AlertDefaultSMSPhone: string;
    AlertDefaultSMSPhoneVerified: boolean;
    DeliverSMS: boolean | null;
}

export class AlertContact {
    AlertContactID: number | null;
    UserID: number;
    Name: string;
    Email: string;
    EmailVerified: boolean;
    SMSCountryCode: string;
    SMSPhone: string;
    SMSPhoneVerified: boolean;
}

export class EnrollAlertDetail
{
    SMSCountryCode: string;
    UsingDefaultSMSPhone: boolean | null;
    SMSPhone: string;
    DeliverSMS: boolean | null;
    EmailVerified: boolean | null;
    UsingDefaultEmail: boolean | null;
    Email: string;
    DeliverEmail: boolean | null;
    AlertContactName: string;
    AlertContactID: number | null;
    SMSPhoneVerified: boolean | null;
    AlertEnrollmentContactID: number | null;
    EventTopic: string;
    Description: string;
    Name: string;
    SMSTemplateID: number | null;
    DeliveryMechSMS: boolean | null;
    EmailTemplateID: number | null;
    DeliveryMechEmail: boolean | null;
    UITemplateID: number | null;
    AlertTypeID: number | null;
    UserID: number | null;
    AlertEnrollmentID: number | null;
    DigestPeriodMinutes: number | null;
}

//Used in alert category tab for selecting sales entities scope
export class AlertScopeCategoryTableData extends AlertsList {
    AlertScopeData: Array<AlertScopesList>
    Enrolled: Boolean | null;
}
//Used in alert delivery tab for selecting contacts to receive alerts
export class AlertEnrollmentContactTableData extends EnrollAlertDetail {
    Contacts: Array<AlertEnrollmentContact>;
}
//Used in alert list tab to display everything in one place
export class AlertEnrollmentListTableData extends EnrollAlertDetail {
    SalesEntities: Array<AlertEnrollmentScope>;
    Contacts: Array<AlertEnrollmentContact>;
}
